import { memo } from 'react'

interface PaginationProps {
  currentSlide: number
  total: number
  styles?: string
}

const Pagination = ({ currentSlide, total, styles }: PaginationProps) => {
  const defaultStyles = 'pointer-events-none text-xs leading-[14px] text-white z-1'
  const className = styles ? styles + ' ' + defaultStyles : defaultStyles

  return (
    <span className={className}>
      {currentSlide + 1} / {total}
    </span>
  )
}

export default memo(Pagination)
